<!--
 * @Author: wufei
 * @Date: 2020-08-13 16:06:54
 * @LastEditTime: 2020-12-08 09:10:40
 * @Description:
 * @FilePath: \mobile-revive\src\views\report\reviveReport\first.vue
-->
<template>
  <div class="first-report">
    <report-menu :cur="active" :is-obtains="isObtains" @switchMenu="switchMenu" />
    <!-- 利润率 start -->
    <div class="profit">
      <div class="core">
        <div class="left">
          <div class="label">投资版利润率</div>
          <div class="value">{{ replayForm.cifiNetProfitRatio | keepInteger(1) | unitFormat('%') }}</div>
        </div>
        <div class="right">
          <div class="label">首开版利润率</div>
          <div class="value">{{ replayForm.firstProfitsMargin | keepInteger(1) | unitFormat('%') }}</div>
        </div>
      </div>
      <div class="notice">
        * 非我司获取项目为预估值
      </div>
    </div>
    <!-- 利润率 end -->

    <!-- 首开复盘 start -->
    <div class="first-revive">
      <title-comp title="首开复盘" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <div style="font-weight: 500; padding: .2rem 0;font-size: 0.28rem;color: #999999;">
              <span class="label">是否遗憾项目：</span>
              <span class="value" style="color: #333333;margin-left: .2rem">{{ replayForm.isRegretProject | filterIsRegret }}</span>
            </div>
            <div v-if="replayForm.isRegretProject == 1" style="font-weight: 500; padding: .2rem 0;font-size: 0.28rem;color: #999999;">
              <span class="label">未投资获取的原因：</span>
              <span class="value" style="color: #333333;margin-left: .2rem">{{ replayForm.notObtainedReason | unitFormat }}</span>
            </div>
            <ell :params="{content:replayForm.firstReopeningContent || '--',renderState:renderState, line:2}" />
            <!-- <div style="font-weight: 500; padding: .2rem 0; font-size: .28rem;color: #999999;border-bottom: 0.01rem solid #EAEAEA;margin-bottom: .15rem">未录入项目原因：</div>
            <ell :params="{content:replayForm.notEnteredReason || '--',renderState:renderState, line:2}" @click.native="callHeight" /> -->
            <table class="qp-table" cellspacing="0" cellpadding="0" style="margin-top:.2rem;">
              <thead>
                <tr>
                  <th width="25%" />
                  <th width="50%">判断偏差<br>原因分析</th>
                  <th width="25%">项目成败<br>影响程度</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in coreItems" :key="'coreItems_'+index">
                  <td>{{ item.label }}</td>
                  <td><ell :params="{content:replayForm[item.field] || '--',renderState:renderState, line:2}" /></td>
                  <td style="text-align:center;">{{ util.getOptionsLabel(effectOptions, replayForm[item.field+'Effect'], 'code','name') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </title-comp>
    </div>
    <!-- 首开复盘 end -->

    <!-- 量价对比 start -->
    <div class="first-revive">
      <title-comp title="量价对比" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <table class="qp-table" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <td width="25%" />
                  <td width="25%">投资版</td>
                  <td width="25%">首开版</td>
                  <td width="25%">偏差</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>首开时间</td>
                  <td>{{ replayForm.openingDate | newParseTime('{y}-{m}-{d}') | unitFormat }}</td>
                  <td>{{ replayForm.realFirstReopeningTime | newParseTime('{y}-{m}-{d}') | unitFormat }}</td>
                  <td class="c-red">{{ deviationTime }}</td>
                </tr>
                <tr>
                  <td>首开价格(元/㎡)</td>
                  <td>{{ replayForm.openingPrice | keepInteger }}</td>
                  <td>{{ replayForm.realFirstAvgPrice | keepInteger }}</td>
                  <!-- <td class="c-red">{{ replayForm.firstAvgDeviationRate | keepInteger(1) | unitFormat('%') }}</td> -->
                  <td class="c-red">{{ replayForm.openingPrice | dataBias(replayForm.realFirstAvgPrice) }}</td>
                </tr>
                <tr>
                  <td>首开去化(㎡)</td>
                  <td>{{ replayForm.firstSalesArea | keepInteger | unitFormat }}</td>
                  <td>{{ replayForm.realFirstMonthReduce | keepInteger }}</td>
                  <!-- <td class="c-blue">{{ replayForm.firstReduceDeviationRate | keepInteger(1) | unitFormat('%') }}</td> -->
                  <td class="c-red">{{ replayForm.firstSalesArea | dataBias(replayForm.realFirstMonthReduce) }}</td>
                </tr>
              </tbody>
            </table>
            <div style="margin-top:.2rem;">
              <div class="trend">
                <span>偏差备注</span>
                <p style="margin-top:.1rem;"><ell :params="{content:replayForm.amountPriceExplain || '--',renderState:renderState, line:2}" /></p>
              </div>
            </div>
          </div>
        </template>
      </title-comp>
    </div>
    <!-- 量价对比 end -->

    <!-- 城市分析 start -->
    <div class="first-revive">
      <div class="title">天时</div>
      <title-comp title="城市分析" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <!-- <SolarTerms v-if="landId" :land-id="landId" /> -->
            <div class="tips">
              <div class="type">投资版</div>
              <div class="trend">
                <span>新房后市研判</span>
                <div v-if="replayForm.invesHouseAfterJudgedText" class="my-button info">{{ replayForm.invesHouseAfterJudgedText }}</div>
              </div>
              <div class="trend">
                <span>研判依据</span>
                <p class="conTxt">{{ replayForm.invesHouseAfterBasis | unitFormat }}</p>
              </div>
              <div class="trend strategy">
                <span>土地后市研判</span>
                <div v-if="replayForm.invesLandAfterJudgedText" class="my-button warn">{{ replayForm.invesLandAfterJudgedText }}</div>
              </div>
              <div class="trend">
                <span>研判依据</span>
                <p class="conTxt">{{ replayForm.invesLandAfterBasis | unitFormat }}</p>
              </div>
              <div class="trend strategy">
                <span class="aftermarketType">投资策略</span>
                <div v-if="replayForm.invesInvestStrategyText" class="my-button grey">{{ replayForm.invesInvestStrategyText }}</div>
                <!-- <p class="conTxt">{{ replayForm.invesInvestStrategyText | unitFormat }}</p> -->
              </div>
            </div>
            <div class="tips">
              <div class="type">首开版</div>
              <div style="font-weight: 500; padding: .2rem 0;font-size: 0.28rem;color: #999999;">
                <span class="label">拿地时节气：</span>
                <span class="value" style="color: #333333;margin-left: .2rem">{{ replayForm.landJieqi | filterDic(solarTermsOptions) }}</span>
              </div>
              <div style="font-weight: 500; padding: .2rem 0;font-size: 0.28rem;color: #999999;">
                <span class="label">首开时节气：</span>
                <span class="value" style="color: #333333;margin-left: .2rem">{{ replayForm.realrstFiJieqi | filterDic(solarTermsOptions) }}</span>
              </div>
              <div class="trend">
                <span>对比拿地时点实际走势</span>
                <p class="conTxt">{{ replayForm.firstLandTrend | houseTrendList }}</p>
              </div>
              <div class="trend">
                <span>城市走势判断偏差说明</span>
                <p class="conTxt">{{ replayForm.firstLandTrendReason | unitFormat }}</p>
              </div>
            </div>
          </div>
        </template>
      </title-comp>
    </div>
    <!-- 城市分析 end -->

    <!-- 市场判断 start -->
    <div class="first-revive">
      <div class="title">地利</div>
      <title-comp title="板块研判" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <!--新版-->
            <table v-if="projectReleaseNum>2" class="qp-table" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <td />
                  <td>投资版</td>
                  <td>首开版</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>客户定位</td>
                  <td>{{ replayJudgeForm.invesDataSource | unitFormat }}</td>
                  <td>{{ util.getOptionsLabel(costomerSource, replayJudgeForm.realDataSource, 'code','name') }}</td>
                </tr>
                <tr>
                  <td>版块属性</td>
                  <td>{{ replayJudgeForm.plateProp | unitFormat }}</td>
                  <td>{{ replayJudgeForm.realSectionAttributes }}</td>
                </tr>
                <tr>
                  <td>未来趋势判断</td>
                  <td>{{ replayJudgeForm.invesTrendJudging | unitFormat }}</td>
                  <td>{{ util.getOptionsLabel(futureTrendJudging, replayJudgeForm.realTrendJudging, 'code','name') }}</td>
                </tr>
              </tbody>
            </table>
            <!--旧版-->
            <template v-else>
              <table class="qp-table" cellspacing="0" cellpadding="0">
                <thead>
                  <tr>
                    <td />
                    <td>投资版</td>
                    <td>首开版</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>需求属性</td>
                    <td>{{ replayForm.demandAttributeName | unitFormat }}</td>
                    <td>{{ replayForm.realPropertyComparison | unitFormat }}</td>
                  </tr>
                  <tr>
                    <td>版块属性</td>
                    <td>{{ replayForm.plateProp | unitFormat }}</td>
                    <td>{{ replayForm.realSectionAttributes | unitFormat }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="tips mt20">
                <div class="type">投资版价格梯度</div>
                <div class="content">
                  <ell :params="{content:replayForm.priceGradient || '--',renderState:renderState, line:2}" />
                </div>
              </div>
              <div class="tips mt20">
                <div class="type">首开版价格梯度</div>
                <div class="content">
                  <ell :params="{content:replayForm.realPriceGradientAttribut || '--',renderState:renderState, line:2}" />
                </div>
              </div>
            </template>
          </div>
        </template>
      </title-comp>
    </div>
    <!-- 市场判断 end -->
    <!-- 客户及产品定位 start -->
    <div class="first-revive">
      <title-comp title="客户定位" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <table class="qp-table" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <td width="20%" />
                  <td width="40%">投资版</td>
                  <td width="40%">首开版</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>客户资源</td>
                  <td>{{ replayForm.invesClientSource | unitFormat }}</td>
                  <td>{{ replayForm.realClientSource | unitFormat }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </title-comp>
    </div>
    <!-- 客户及产品定位 end -->

    <!-- 竞品量价 start -->
    <div class="first-revive">
      <title-comp title="竞品量价" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <div class="tips">
              <div class="type">投资版</div>
              <div class="content">
                <ell :params="{content:replayForm.newhouseConclusion || '--',renderState:renderState, line:2}" />
              </div>
            </div>
            <div class="tips">
              <div class="type">首开版</div>
              <div class="content">
                <ell :params="{content:replayForm.realCompetitionPrice || '--',renderState:renderState, line:2}" />
              </div>
            </div>
          </div>
        </template>
      </title-comp>
    </div>
    <div class="first-revive">
      <div class="title">人和</div>
      <div style="font-weight: 500; padding: .2rem 0;font-size: 0.28rem;color: #999999;">
        <span class="label">是否多元化拿地：</span>
        <span class="value" style="color: #333333;margin-left: .2rem">{{ replayForm.isDiversifyLand | filterIsRegret }}</span>
      </div>
      <div v-if="replayForm.isDiversifyLand == 1" style="font-weight: 500; padding: .2rem 0;font-size: 0.28rem;color: #999999;">
        <span class="label">具体说明：</span>
        <span class="value" style="color: #333333;margin-left: .2rem">{{ replayForm.remark | unitFormat }}</span>
      </div>
      <div style="font-weight: 500; padding: .2rem 0;font-size: 0.28rem;color: #999999;">
        <span class="label">团队能力评价：</span>
        <span class="value" style="color: #333333;margin-left: .2rem">{{ replayForm.teamAbilityEvaluate | unitFormat }}</span>
      </div>
      <title-comp title="产品定位" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <div class="pic">
              <div class="tit mt20">投资版方案图</div>
              <div v-if="replayForm.isPlan">
                <vanImage
                  v-if="replayForm.designImgUrl"
                  class="mt20"
                  :images="replayForm.designImgUrl"
                />
              </div>
              <p v-else class="mt20">无投资版方案</p>
            </div>

            <div class="pic">
              <div class="tit mt20">报批方案图</div>
              <vanImage
                v-if="replayForm.realDesignImgUrl"
                class="mt20"
                :images="replayForm.realDesignImgUrl"
              />
            </div>

            <div class="tit mt20">产品类型表</div>
            <table class="qp-table mt20 border" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <td width="20%" rowspan="2">产品类型</td>
                  <td colspan="2">占比（%）</td>
                  <td colspan="2">均价（元/㎡）</td>
                </tr>
                <tr>
                  <td width="20%">投资</td>
                  <td width="20%">首开</td>
                  <td width="20%">投资</td>
                  <td width="20%">首开</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in productTypeData" :key="index">
                  <td>{{ item.mappingProductTypeName }}</td>
                  <td class="bg-pink">{{ item.holdRatio }}</td>
                  <td class="bg-blue">{{ item.realholdRatio }}</td>
                  <td class="bg-pink">{{ item.averagePrice }}</td>
                  <td class="bg-blue">{{ item.realaveragePrice }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </title-comp>
    </div>
    <!-- 竞品量价 start -->

    <div v-if="file && file.pkId" class="view-detail" @click="downloadFile">
      <icon name="description" />
      <div>查看详细</div>
      <div>复盘报告</div>
    </div>
  </div>
</template>

<script>
import SolarTerms from '@/components/SolarTerms'
import TitleComp from '@/components/TitleComp'
import reportMenu from './menu'
import ell from '@/components/Ell'
import vanImage from '@/components/van-img'
import { Lazyload, Icon } from 'vant'
import { getNewReplayFrom } from '@/api/revive'
import { getDataDict } from '@/api/dataDict'
import { getLandHead } from '@/api/land'
import { getfileList, downLoadFile } from '@/api/fileOperate'
import moment from 'moment'
import util from '@/utils/util'
export default {
    name: 'FirstReport',
    components: {
        TitleComp,
        reportMenu,
        ell,
        vanImage,
        Icon,
        SolarTerms
    },
    filters: {
        filterDic(val, options) {
            if (options.length !== 0 && val) {
                return options.filter(el => el.code == val)[0].name
            }
            return '--'
        },
        dataTofixed(val) {
            if (val) {
                return val.toFixed(2)
            }
        },
        dataBias(data1, data2) {
            var iData
            if (data1 && data2) {
                iData = (Number(data2) - Number(data1)) / Number(data1)
                return parseFloat(iData * 100).toFixed(1) + '%'
            }
            return '--'
        },
        houseTrendList(val) {
            if ( val === 0 ) {
                return '骤升'
            } else if ( val === 1 ) {
                return '升温'
            } else if ( val === 2 ) {
                return '平稳'
            } else if ( val === 3 ) {
                return '降温'
            } else if ( val === 4 ) {
                return '骤降'
            }
            return '--'
        },
        filterIsRegret(val) {
            switch (val) {
            case 0:
                return '否'
            case 1:
                return '是'

            default:
                return '--'
            }
        }
    },
    props: {
        active: {
            type: String,
            default: 'basic'
        }
        // replayForm: {
        //     type: Object,
        //     default: () => { return {} }
        // }
    },
    data() {
        return {
            util,
            landId: this.$route.query['landId'],
            renderState: false,
            policyType: '',
            productTypeData: [],
            replayForm: {
                // 基本情况
                landName: '', // 地块信息
                projectName: '', // 项目名称
                cifiNetProfitRatio: '', // 投资版利润率
                firstProfitsMargin: '', // 首开利润率
                participationTime: '', // 拿地时间
                floorArea: '', // 占地面积
                areaMeterCapacity: '', // 计容面积
                plotRatio: '', // 容积率
                limitHigh: '', // 限高
                totalPrice: '', // 成交价格
                overPriceRate: '', // 溢价率
                nominalFloorPrice: '', // 名义楼板价
                realFloorPrice: '', // 实际楼板价
                otherRestrictions: '', // 特殊限制要求
                housingPrices: '', // 开发企业
                // 首开复盘
                firstReopeningContent: '', // 首开复盘
                // 量价对比
                openingDate: '', // 投资版 首开时间
                openingPrice: '', // 投资版 首开价格
                firstSalesArea: '', // 投资版 首开去化

                realFirstReopeningTime: '', // 首开版 首开时间
                realFirstAvgPrice: '', // 首开版 首开价格
                realFirstMonthReduce: '', // 首开版 首开去化

                firstDeviationRate: '', // 偏差 首开时间
                firstAvgDeviationRate: '', // 偏差 首开价格
                firstReduceDeviationRate: '', // 偏差 首开去化

                amountPriceExplain: '', // 偏差备注

                // 城市分析
                invesHouseAfterJudgedText: '', // 新房后市研判
                invesHouseAfterBasis: '', // 研判依据
                invesLandAfterJudgedText: '', // 土地后市研判
                invesLandAfterBasis: '', // 研判依据
                invesInvestStrategyText: '', // 投资策略

                firstLandTrend: '', // 对比拿地时点实际走势
                firstLandTrendReason: '', // 城市走势判断偏差说明

                // 市场判断
                demandAttributeName: '', // 投资版 需求属性
                plateProp: '', // 投资版 板块属性
                priceGradient: '', // 投资版 价格梯度
                realPropertyComparison: '', // 首开版 需求属性
                realSectionAttributes: '', // 首开版 板块属性
                realPriceGradientAttribut: '', // 首开版 价格梯度
                // 客户及产品定位
                invesClientSource: '', // 投资版 客户来源
                realClientSource: '', // 首开版 客户来源
                // 投资版设计方案
                // 首开报批方案
                productList: '', // 产品类型
                // 竞品量价
                newhouseConclusion: '', // 投资版
                realCompetitionPrice: '', // 首开版
                // 20210927新增字段
                isRegretProject: '', // 是否遗憾项目
                landJieqi: '', // 拿地时节气
                realrstFiJieqi: '', // 首开时节气
                isDiversifyLand: '', // 是否多元化拿地
                remark: '', // 备注
                // 20211103
                teamAbilityEvaluate: '', // 团队能力评价
                notObtainedReason: '', // 未投资获取的原因
                chanceJudgement: '', // 时机判断：
                plateJudgment: '', // 板块判断：
                competitiveEnv: '', // 竞争环境：
                customerLocate: '', // 客户定位：
                productPlan: '', // 产品方案：
                tradersAbility: '', // 操盘能力：
                policyChange: '', // 政策变化：
                otherFactors: '', // 其他因素：
                chanceJudgementEffect: '', // 时机判断：
                plateJudgmentEffect: '', // 板块判断：
                competitiveEnvEffect: '', // 竞争环境：
                customerLocateEffect: '', // 客户定位：
                productPlanEffect: '', // 产品方案：
                tradersAbilityEffect: '', // 操盘能力：
                policyChangeEffect: '', // 政策变化：
                otherFactorsEffect: '' // 其他因素：
            },
            projectReleaseNum: 2, // 项目版本
            dictRequire: [901100, 404500, 404600, 1107200, 101415], // 必须要请求字典数据
            stanceOption: [], // 板块属性 20210327
            futureTrendJudging: [], // 未来趋势判断  20210327
            costomerSource: [], // 客户来源  20210327
            replayJudgeForm: {
                realTrendJudging: '', //  首开-未来趋势判断
                realDataSource: '', // 首开 客户来源
                realSectionAttributes: '', // 首开板块属性
                invesDataSource: '', // 投资版客户来源  20210327
                plateProp: '', //  投资版板块属性
                invesTrendJudging: '' // 投资-未来走势判断 20210327
            },
            isObtains: 0,
            file: {},
            deviationTime: '',
            solarTermsOptions: [],
            coreItems: [
                {label: '时机判断：', field: 'chanceJudgement', placeHolder: '拿地时和当前对城市时机的判断是否一致？拿地时点是否在好的时机上？'},
                {label: '板块判断：', field: 'plateJudgment', placeHolder: '拿地时和当前对板块的判断是否一致？是否为领涨抗跌的主流板块？'},
                {label: '竞争环境：', field: 'competitiveEnv', placeHolder: '周边竞品量价？拿地后是否出现大量新增供应？与拿地时的供地摸排是否一致？'},
                {label: '客户定位：', field: 'customerLocate', placeHolder: '客群来源？客户以自住为主、还是投资为主？投资判断是否准确？'},
                {label: '产品方案：', field: 'productPlan', placeHolder: '产品属性是刚需还是改善？是否精准匹配客户定位？是否存在产品溢价？'},
                {label: '操盘能力：', field: 'tradersAbility', placeHolder: '包括但不限于团队的营销能力、运营能力、非住解题能力、合作管理等'},
                {label: '政策变化：', field: 'policyChange', placeHolder: '是否出现政策变化？投资阶段是否预判到？'},
                {label: '其他因素：', field: 'otherFactors', placeHolder: '其他影响项目成败的因素'}
            ],
            effectOptions: []
        }
    },
    created() {
        this.dictRequire.forEach(item => {
            this.getDict(item)
        })
        this.fetchReplayFrom()
        // this.getFile()
        // console.log(222222222)
    },
    methods: {
        // 查询字典数据
        getDict(type) {
            getDataDict({
                type
            }).then(res => {
                switch (type) {
                case 901100:
                    // 板块属性
                    this.stanceOption = res
                    break
                case 404500:
                    // 未来走势判断
                    this.futureTrendJudging = res
                    break
                case 404600:
                    // 客户来源
                    this.costomerSource = res
                    break
                case 1107200:
                    // 首开节气
                    this.solarTermsOptions = res
                    break
                case 101415:
                    this.effectOptions = res
                    break
                default:
                    break
                }
            })
        },
        // 项目 详情
        async getProjectReleaseNum() {
            await getLandHead(this.landId).then(res => {
                this.projectReleaseNum = res.releaseNum
            })
        },
        downloadFile() {
            downLoadFile(this.file.savePath)
        },
        switchMenu(type) {
            this.$emit('switchMenu', type)
        },
        // 查询复盘from
        async fetchReplayFrom() {
            await this.getProjectReleaseNum()
            await getNewReplayFrom(this.landId).then(res => {
                this.replayForm = res || {}
                this.city = res.city
                if (this.projectReleaseNum > 2) {
                    for (let key in this.replayJudgeForm) {
                        this.$set(this.replayJudgeForm, key, res[key])
                    }
                }
                this.productTypeData = res.productList ? JSON.parse(res.productList) : []
                this.isObtains = res.isObtains // 是否我司获取
                this.deviationTime = this.dateDiff(res.openingDate, res.realFirstReopeningTime)
                this.renderState = true
                // this.replayForm.firstAvgDeviationRate = res.firstAvgDeviationRate || this.dataBias(res.openingPrice, res.realFirstAvgPrice)
                // this.replayForm.firstReduceDeviationRate = res.firstAvgDeviationRate || this.dataBias(res.firstSalesArea, res.realFirstMonthReduce)
            })
        },
        // 计算时间差
        dateDiff(sDate1, sDate2) { // sDate1和sDate2是2006-12-18格式
            console.log(sDate1, sDate2, 'sDate1, sDate2')
            if (sDate1 && sDate2) {

                let sDate3 = sDate1.split('T')[0]
                let sDate4 = sDate2.split('T')[0]
                // let temp1 = Math.floor(new Date(sDate3).getTime() / 1000)
                // let temp2 = Math.floor(new Date(sDate4.replace(/-/g, '/')).getTime() / 1000)

                let temp1 = moment(sDate1).valueOf()
                let temp2 = moment(sDate2).valueOf()
                console.log(temp1, 'temp1', temp2)
                let temp3 = (temp2 - temp1) / 60 / 60 / 24 / 1000
                console.log(temp3, 'temp3')
                return temp3 > 0 ? Math.floor(temp3) + '天' : Math.ceil(temp3) + '天'
            }
            return '--'
        },
        // 计算数据偏差
        dataBias(data1, data2) {
            var iData
            if (data1 && data2) {
                iData = (Number(data2) - Number(data1)) / Number(data1)
                return parseFloat(iData * 100).toFixed(1) + '%'
            }
            return '--'
        },
        getFile() {
            const params = {
                businessId: this.landId,
                typeCode: 26
            }
            getfileList(params).then(res => {
                if (res.length) {
                    this.file = res[res.length - 1]
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
  .first-report {
    font-family:PingFangTC-Medium,PingFangTC;
    background:rgba(248,248,248,1);
    overflow-y: auto;
    box-sizing: border-box;
    font-size:.28rem /* 28/100 */;
    width:100%;
    height:100%;
    // height:9999px;
    padding-bottom: 1.5rem /* 150/100 */;

    .mt20 {
      margin-top:.2rem /* 20/100 */
    }

    .bar-container {
      .bar-chart {
        height:6.5rem /* 395/100 */
      }
    }

    .view-detail {
      box-sizing: border-box;
      width:1.1rem /* 110/100 */;
      height:1.39rem /* 139/100 */;
      background:rgba(39,97,255,1);
      box-shadow:0 .08rem /* 8/100 */ .24rem /* 24/100 */ 0 rgba(39,97,255,0.5);
      border-radius:.1rem /* 10/100 */ 0 0 .1rem /* 10/100 */;
      position: fixed;
      right:0;
      bottom:2rem /* 200/100 */;
      text-align:center;
      padding:.23rem /* 23/100 */ 0;
      color:white;
      font-size:.2rem /* 20/100 */;
      font-weight:400;
      i {
        font-size:.4rem /* 4  0/100 */;
        margin-bottom:.1rem /* 10/100 */;
      }
      div {
        margin-bottom:.05rem /* 5/100 */;
      }
    }

    .my-button {
      box-sizing: border-box;
      height:4px;
      border:1px solid rgba(151,151,151,1);
      text-align: center;
      display:inline-block;
      color:rgba(151,151,151,1);
      margin-right:.2rem /* 20/100 */;
      line-height: .6rem /* 60/100 */;
      padding:0 .2rem /* 20/100 */;
    }

    .my-button.success {
      height:.44rem /* 44/100 */;
      line-height:.44rem /* 40/100 */;
      // margin-top:23px
      border:1px solid rgba(183,235,143,1);
      color:rgba(82,196,26,1);
      font-size:.24rem /* 24/100 */;
      border-radius: .04rem /* 4/100 */;
      margin-left:.2rem /* 20/100 */;
      background:rgba(246,255,237,1);
    }

    .my-button.info {
      height:.44rem /* 44/100 */;
      line-height:.44rem /* 40/100 */;
      border:1px solid rgba(145,213,255,1);
      color:rgba(39,97,255,1);
      font-size:.24rem /* 24/100 */;
      border-radius: .04rem /* 4/100 */;
      margin-left:.2rem /* 20/100 */;
      background:rgba(230,247,255,1);
    }

    .my-button.warn {
      height:.44rem /* 44/100 */;
      line-height:.44rem /* 40/100 */;
      border:1px solid rgba(255,187,150,1);
      color:rgba(250,84,28,1);
      font-size:.24rem /* 24/100 */;
      border-radius: .04rem /* 4/100 */;
      margin-left:.2rem /* 20/100 */;
      background:rgba(255,242,232,1);
    }
    .my-button.grey {
      height:.44rem /* 44/100 */;
      line-height:.44rem /* 40/100 */;
      border:1px solid #e9e9eb;
      background-color: #f4f4f5;
      border-color: #e9e9eb;
      color: #909399;
      font-size:.24rem /* 24/100 */;
      border-radius: .04rem /* 4/100 */;
      margin-left:.2rem /* 20/100 */;
    }
    .my-button.white {
      height:.44rem /* 44/100 */;
      line-height:.44rem /* 40/100 */;
      border:1px solid white;
      color:rgba(76,162,170,1);
      font-size:.24rem /* 24/100 */;
      border-radius: .04rem /* 4/100 */;
      margin-left:.2rem /* 20/100 */;
      background:white;
    }

    .report-menu {
      margin-top:.2rem /* 20/100 */;
    }

    .profit {
      background: white;
      box-sizing: border-box;
      margin-top:.2rem /* 20/100 */;
      height:2.71rem /* 271/100 */;
      border-top:.01rem /* 1/100 */ solid #DDDDDD;
      border-bottom:.01rem /* 1/100 */ solid #DDDDDD;
      margin-bottom:.2rem /* 20/100 */;
      .core {
        margin:.65rem /* 65/100 */ 1.3rem /* 130/100 */;
        margin-bottom:0;
        height:1.2rem /* 120/100 */;
        display:flex;
        .label {
          font-size:.24rem /* 24/100 */;
          color:rgba(102,102,102,1);
        }

        .left {
          flex:1;
          border-right:.01rem /* 1/100 */ solid rgba(0,0,0,0.13);
          text-align:center;
          .value {
            font-size:.42rem /* 42/100 */;
            color:rgba(39,97,255,1);
            margin-top:.23rem /* 23/100 */;
            font-weight:500;
          }
        }
        .right {
          flex:1;
          text-align:center;
          .value {
            font-size:.42rem /* 42/100 */;
            color:rgba(228,14,14,1);
            margin-top:.23rem /* 23/100 */;
            font-weight:500;
          }
        }
      }
      .notice {
        font-size:.2rem /* 20/100 */;
        color:rgba(153,153,153,1);
        text-align: right;
        padding-right:.88rem /* 88/100 */;
        margin-top:.05rem /* 5/100 */;
      }
    }

    .first-revive {
      box-sizing: border-box;
      width:100%;
      overflow: hidden;
      padding:.2rem;
      background: white;
      margin-bottom:.2rem /* 20/100 */;
      .title {
          font-size:.35rem;
          color: #333333;
          padding: .28rem 0;
          font-weight: bold;
      }
      .content {
        font-size:.28rem /* 28/100 */;
        color:rgba(51,51,51,1);
        margin-top:.2rem;
      }
    }

    .c-red{
      color:#E40E0E;
    }

    .pic {
      border-bottom:.01rem /* 1/100 */ solid #EAEAEA;
      padding-bottom:.3rem /* 30/100 */;
    }

    .tips {
      // height:3.7rem /* 370/100 */;
      background:rgba(250,248,243,1);
      padding:.2rem /* 20/100 */;
      margin-bottom:.2rem /* 20/100 */;
      .type {
        font-size:.3rem /* 30/100 */;
        font-weight:500;
        color:rgba(51,51,51,1);
        margin-bottom:.24rem /* 24/100 */;
      }
      .trend {
        font-size:.28rem /* 28/100 */;
        color:rgba(51,51,51,1);
        margin-top:.1rem;
        padding: .1rem 0;
        span {
          color:rgba(153,153,153,1);
        }
        .conTxt{
          line-height: .42rem;
          padding: .1rem 0;
        }
      }
      .strategy{
        margin-top:.24rem
      }
      .content {
        font-size:.28rem /* 28/100 */;
        line-height:.45rem /* 28/100 */;
        margin:.24rem /* 24/100 */ 0;
      }
    }

    .tips:nth-of-type(even) {
      background:rgba(239,243,251,1);
    }

    .c-blue{
      color:#2761FF;
    }

    .tit {
      font-size:.3rem /* 30/100 */;
      font-weight:500;
    }

    .qp-table {
      table-layout: fixed;
      width:100%;
      border:.01rem /* 1/100 */ solid rgba(239,239,239,1);
      border-bottom:none;
      tr {
        height:.8rem /* 80/100 */;
      }
      td {
        border-bottom:.01rem /* 1/100 */ solid rgba(239,239,239,1);
        padding:.2rem /* 10/100 */;
      }
      thead {
        tr {
          background:rgba(250,250,250,1);
          font: size .24rem /* 24/100 */;
          color:rgba(153,153,153,1);
        }
      }
      tbody {
        tr {
          font-weight:500;
          font-size:.24rem /* 24/100 */;
          color:rgba(51,51,51,1);
        }
      }
    }

    .qp-table.border {
      td {
        font-size:.24rem /* 24/100 */;
        text-align: center;
        border-right:.01rem /* 1/100 */ solid rgba(239,239,239,1);
      }
      tbody {
        .bg-blue {
          background:rgba(239,243,251,1);
        }
        .bg-pink {
          background:rgba(250,248,243,1);
        }
      }

    }

  }
</style>
